import type { AfterResponseHook } from "ky";
import { setSession } from "@/stores/authStore";
import { setUserInfo } from "@/stores/userStore";

/**
 * A 401 from a proxied call means our session ended — expired, or logged out
 * in another tab — not that the upstream refused us. The proxy answers 401
 * before it ever contacts an upstream.
 */
export const createUnauthorizedHook =
  (): AfterResponseHook =>
  ({ response }) => {
    if (response.status === 401) {
      setSession(null);
      setUserInfo(null);
    }
    return response;
  };
